/* Mapping props to a function instead of the actual state helps ensure the data stays up to date. */
function refreshCurrentID(state) {
	if (state.current) {
		return state.current;
	}
	return null;
}


function refreshCategories(state) {
	let result = []
	if(state.categories){
		if(state.activated[state.dateString]){
			const currentActivated = state.activated[state.dateString]
			result = state.categories.map((item, x) => ({...item, activated: currentActivated[x]}))
		} else {
			result = state.categories.map(item => ({...item, activated: {schedule: []}}))
		}

	}
	return result
}

function refreshDate(state) {
	if(state.date){
		return state.date
	}
	return null
}

function isLoading(state) {
	if(state.loading){
		return state.loading
	}
	return true
}

function refreshDateString(state) {
	if(state.dateString){
		return state.dateString
	}
	return null
}

function refreshStagedChanges(state) {
	let stagedResult = state.staged
	if(state.stagedDate[state.dateString]){
		const currentDate = state.dateString
		stagedResult = state.stagedDate[currentDate]

	}

	return stagedResult
}

function refreshCurrentToth(state) {
	if(state.dateString && state.toth){
		if(state.toth[state.dateString]){
			return state.toth[state.dateString]
		}
	}
	return {date: '', schedule: []}
}

function refreshSelectedDate(state) {
	if (state.selectedDate) {
		return state.selectedDate
	}
	return ''
}

export default {
	refreshCurrentID,
	refreshCategories,
	refreshDate,
	refreshDateString,
	refreshStagedChanges,
	isLoading,
	refreshCurrentToth,
	refreshSelectedDate
};
